import {
  PieChart, Pie, Cell, Tooltip, ResponsiveContainer,
  BarChart, Bar, XAxis, YAxis, CartesianGrid, LabelList,
  AreaChart, Area,
} from "recharts";
import { PALETTE } from "../../lib/dashConstants";
import { fmtN } from "../../lib/format";

export function DonutChart({ data, onSliceClick }) {
  const total = data.reduce((a, b) => a + b.value, 0);
  return (
    <ResponsiveContainer width="100%" height={280}>
      <PieChart>
        <Pie
          data={data} dataKey="value" nameKey="name"
          cx="50%" cy="50%" innerRadius={55} outerRadius={95}
          paddingAngle={2} stroke="#fff" strokeWidth={2}
          label={({ value }) => `${((value/total)*100).toFixed(0)}%`}
          labelLine={false}
          onClick={(d) => onSliceClick && onSliceClick(d.name)}
          style={{ cursor: onSliceClick ? "pointer" : "default" }}
        >
          {data.map((_, i) => <Cell key={i} fill={PALETTE[i % PALETTE.length]} />)}
        </Pie>
        <Tooltip formatter={(v, n) => [`${fmtN(v)} (${((v/total)*100).toFixed(1)}%)`, n]}
          contentStyle={{ borderRadius: 8, border: "1px solid #D6E2F0", fontSize: 12 }} />
      </PieChart>
    </ResponsiveContainer>
  );
}

export function StatusLegend({ data }) {
  const total = data.reduce((a, b) => a + b.value, 0);
  return (
    <div style={{ display: "grid", gap: 8, marginTop: 8 }}>
      {data.map((d, i) => (
        <div key={d.name} style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 13 }}>
          <span style={{ width: 12, height: 12, borderRadius: 3, background: PALETTE[i % PALETTE.length], flexShrink: 0 }} />
          <span style={{ flex: 1 }}>{d.name}</span>
          <span style={{ color: "var(--muted)", fontVariantNumeric: "tabular-nums" }}>
            {fmtN(d.value)} · {((d.value/total)*100).toFixed(1)}%
          </span>
        </div>
      ))}
    </div>
  );
}

export function HorizontalBar({ data, onBarClick }) {
  const height = Math.max(280, data.length * 36);
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} layout="vertical" margin={{ top: 8, right: 38, bottom: 8, left: 8 }}>
        <CartesianGrid horizontal={false} stroke="#EEF3F9" />
        <XAxis type="number" tick={{ fill: "#6B7A90", fontSize: 11 }} axisLine={{ stroke: "#D6E2F0" }} />
        <YAxis type="category" dataKey="name" tick={{ fill: "#1A2433", fontSize: 12, fontWeight: 500 }}
               width={170} axisLine={false} tickLine={false} />
        <Tooltip cursor={{ fill: "rgba(46,134,222,0.08)" }} formatter={(v) => [fmtN(v), "Jumlah"]}
          contentStyle={{ borderRadius: 8, border: "1px solid #D6E2F0", fontSize: 12 }} />
        <Bar dataKey="value" fill="#1E5AA8" radius={[0, 6, 6, 0]} barSize={20}
             onClick={(d) => onBarClick && onBarClick(d.name)}
             style={{ cursor: onBarClick ? "pointer" : "default" }}>
          <LabelList dataKey="value" position="right" style={{ fill: "#0B2545", fontWeight: 700, fontSize: 11 }} />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}

export function TimelineChart({ data, onPointClick }) {
  return (
    <ResponsiveContainer width="100%" height={260}>
      <AreaChart data={data} margin={{ top: 8, right: 20, bottom: 8, left: -8 }}
                 onClick={(s) => { if (onPointClick && s?.activeLabel) onPointClick(s.activeLabel); }}>
        <defs>
          <linearGradient id="areaFill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#2E86DE" stopOpacity={0.45} />
            <stop offset="100%" stopColor="#2E86DE" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid stroke="#EEF3F9" vertical={false} />
        <XAxis dataKey="name" tick={{ fill: "#6B7A90", fontSize: 10 }} axisLine={{ stroke: "#D6E2F0" }} />
        <YAxis tick={{ fill: "#6B7A90", fontSize: 11 }} axisLine={false} tickLine={false} />
        <Tooltip formatter={(v) => [fmtN(v), "Aktivitas"]}
          contentStyle={{ borderRadius: 8, border: "1px solid #D6E2F0", fontSize: 12 }} />
        <Area type="monotone" dataKey="value" stroke="#1E5AA8" strokeWidth={2.5}
              fill="url(#areaFill)" dot={{ fill: "#1E5AA8", r: 3 }} activeDot={{ r: 5 }} />
      </AreaChart>
    </ResponsiveContainer>
  );
}
